import React, {useCallback, useContext, useMemo} from 'react';

import Element from '~/src/components/element/Element';

import {classNameByType, classNames} from '~/src/utilities/helpers/css';
import {toPascalCase} from '~/src/utilities/helpers/string';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import {ElementTypes} from '~/src/utilities/constants/types';

import css from './InfoBox.module.scss';

const normalize = (data) => ({
    type: 'infobox',
    style: data.style || {},
    content: data.type === ElementTypes.INFOBOX ? [data.title, ...data.content] : data.elements
});

const renderElement = ({element, meta}, index) => {
    const className = classNameByType(css, element.type);

    return (
        <div key={index} className={className}>
            <Element {...element} meta={meta} />
        </div>
    );
};

const InfoBox = (props) => {
    const {siteArea} = useContext(SettingsContext);
    const {style, content} = useMemo(() => normalize(props), [props]);

    const render = useCallback((element, index) => renderElement({element, meta: props.meta}, index), [props.meta]);

    const {containerType = '_infobox_summary'} = style;
    const type = `type${toPascalCase(containerType)}`;
    const customStyle = props.meta.teaser.default?.styles?.name;

    const className = classNames(css, 'infoBox', siteArea, type, customStyle);

    return (
        <div className={className} data-testid="InfoBox">
            {content.map(render)}
        </div>
    );
};

export default InfoBox;
